import React from 'react';

const ContactsAdmin = () => {
    return (
        <div>
            <h2>Редагування Контактів</h2>
            <p>Тут буде форма для редагування контактної інформації.</p>
        </div>
    );
};

export default ContactsAdmin; 